export const ENQUEUE_ADMIN_SNACKBAR_MESSAGE = 'ENQUEUE_ADMIN_SNACKBAR_MESSAGE';

export const enqueueAdminSnackbarMessage = (message, messageOptions) => {
    return {
        type: ENQUEUE_ADMIN_SNACKBAR_MESSAGE,
        message,
        messageOptions
    };
};
